{
  "beam": { "range": 60, "socket": "HP_LASER_C", "assistDeg": 1.5, "anchorRadius": 0.6, "spillRadius": 1.5, "cutSeconds": [1.5, 3.0] },
  "tractor": { "coneDeg": 15, "pullAccel": 6, "maxSpeed": 15, "captureDistance": 12, "holdPoint": [0, 0, -14] },
  "coolant": { "damage": 60, "radius": 25 },
  "bands": { "intact": 0.8, "serviceable": 0.5 },
  "tiers": {
    "byRegion": { "gate": [0.8, 0.18, 0.02], "mid": [0.6, 0.32, 0.08], "deep": [0.45, 0.41, 0.14], "rim": [0.35, 0.47, 0.18] },
    "maxIntactMk3": { "gate": 0.02, "mid": 0.03, "deep": 0.04, "rim": 0.05 }
  },
  "rush": { "byRegion": { "gate": 0, "mid": 0.05, "deep": 0.12, "rim": 0.2 }, "graveyardMult": 1.5 },
  "graveyardSites": { "extraSites": 2, "minSpacingM": 1500, "storyClearM": 2000, "dockClearM": 2000 },
  "recondition": {
    "reactor": { "goods": { "electronics": 6, "drive_parts": 2 } },
    "weapon": { "goods": { "weapon_parts": 3, "electronics": 0.5 } },
    "shieldGen": { "goods": { "electronics": 5, "hull_plating": 0.5 } },
    "thruster": { "goods": { "drive_parts": 1, "hull_plating": 0.5 } }
  },
  "coreDelivery": { "faction": "holdfast", "standing": 3, "perRegion": { "gate": 1, "mid": 1.5, "deep": 2, "rim": 2.5 } },
  "hulks": { "maxLocal": 3, "maxClaimed": 3 },
  "wrecks": {
    "combatLifeSeconds": 1200,
    "lootedLifeSeconds": 60,
    "drag": 0.05,
    "partChance": 0.7,
    "condition": [0.2, 1.0],
    "maxWrecks": 40,
    "maxParts": 192,
    "freedPush": 0.5
  },
  "layouts": {
    "interceptor": [
      { "type": "reactor", "at": { "bounds": [0, 0.1, 0.45] } },
      { "type": "weapon", "at": { "socket": "HP_LASER_L" } },
      { "type": "weapon", "at": { "socket": "HP_LASER_R" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_C" } },
      { "type": "shieldGen", "at": { "bounds": [0, 0.6, 0.05] } },
      { "type": "radiator", "at": { "bounds": [0.55, 0.2, 0.25] } }
    ],
    "gunship": [
      { "type": "reactor", "at": { "bounds": [0, 0.2, 0.4] } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_L" } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_R" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "shieldGen", "at": { "bounds": [0, 0.7, -0.15] } },
      { "type": "radiator", "at": { "bounds": [-0.8, 0.1, 0.3] } },
      { "type": "radiator", "at": { "bounds": [0.8, 0.1, 0.3] } },
      { "type": "dataCore", "at": { "bounds": [0, 0.5, -0.55] } }
    ],
    "hauler": [
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "radiator", "at": { "bounds": [0.8, 0.5, 0.1] } },
      { "type": "cargoPod", "at": { "bounds": [0, -0.2, -0.05] } }
    ],
    "miner": [
      { "type": "reactor", "at": { "bounds": [0, 0, 0.45] } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "radiator", "at": { "bounds": [-0.7, 0.3, 0.3] } }
    ],
    "cutter": [
      { "type": "reactor", "at": { "bounds": [0, -0.7, 0.4] } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_L" } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_R" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "shieldGen", "at": { "bounds": [0, -0.45, 0.05] } },
      { "type": "radiator", "at": { "bounds": [-0.8, -0.6, 0.5] } },
      { "type": "radiator", "at": { "bounds": [0.8, -0.6, 0.5] } },
      { "type": "dataCore", "at": { "bounds": [0, -0.2, -0.35] } }
    ],
    "salvager": [
      { "type": "reactor", "at": { "bounds": [0, 0, 0.45] } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "radiator", "at": { "bounds": [0.7, 0.3, 0.2] } },
      { "type": "cargoPod", "at": { "bounds": [0, -0.6, 0.1] } }
    ],
    "hauler_large": [
      { "type": "reactor", "at": { "bounds": [0, 0, 0.75] } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_T" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_C" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "radiator", "at": { "bounds": [0.8, 0.5, 0.1] } },
      { "type": "radiator", "at": { "bounds": [-0.8, 0.5, 0.1] } },
      { "type": "cargoPod", "at": { "bounds": [0.5, -0.2, -0.3] } },
      { "type": "cargoPod", "at": { "bounds": [-0.5, -0.2, 0.2] } }
    ],
    "corvette": [
      { "type": "reactor", "at": { "bounds": [0, -0.3, 0.4] } },
      { "type": "weapon", "at": { "socket": "HP_PDC_L" } },
      { "type": "weapon", "at": { "socket": "HP_LASER_R" } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_F" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "shieldGen", "at": { "bounds": [0, 0.3, 0.1] } },
      { "type": "radiator", "at": { "bounds": [-0.8, -0.2, 0.5] } },
      { "type": "radiator", "at": { "bounds": [0.8, -0.2, 0.5] } },
      { "type": "dataCore", "at": { "bounds": [0, 0.5, -0.2] } }
    ],
    "kestrel": [{ "type": "cargoPod", "at": { "bounds": [0, 0, 0.2] } }],
    "tethys_gannet": [
      { "type": "reactor", "at": { "bounds": [0, 0, 0.75] } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_T" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L2" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "radiator", "at": { "bounds": [0.8, 0.5, 0.1] } },
      { "type": "radiator", "at": { "bounds": [-0.8, 0.5, 0.1] } },
      { "type": "cargoPod", "at": { "bounds": [0.5, -0.2, -0.3] } },
      { "type": "cargoPod", "at": { "bounds": [-0.5, -0.2, 0.2] } }
    ],
    "tethys_skua": [
      { "type": "reactor", "at": { "bounds": [0, 0, 0.75] } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_T" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L2" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "radiator", "at": { "bounds": [0.8, 0.5, 0.1] } },
      { "type": "radiator", "at": { "bounds": [-0.8, 0.5, 0.1] } },
      { "type": "cargoPod", "at": { "bounds": [0.5, -0.2, -0.3] } },
      { "type": "cargoPod", "at": { "bounds": [-0.5, -0.2, 0.2] } }
    ],
    "varro_warhound": [
      { "type": "reactor", "at": { "bounds": [0, 0, 0.6] } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_FL" } },
      { "type": "weapon", "at": { "socket": "HP_TURRET_AR" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_C" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "shieldGen", "at": { "bounds": [0, 0.4, 0.1] } },
      { "type": "radiator", "at": { "bounds": [0.8, 0.3, 0.2] } },
      { "type": "radiator", "at": { "bounds": [-0.8, 0.3, 0.2] } },
      { "type": "dataCore", "at": { "bounds": [0, 0.5, -0.4] } }
    ],
    "varro_mastiff_b": [
      { "type": "reactor", "at": { "bounds": [0, -0.3, 0.4] } },
      { "type": "weapon", "at": { "socket": "HP_PDC_L" } },
      { "type": "weapon", "at": { "socket": "HP_LASER_R" } },
      { "type": "weapon", "at": { "socket": "HP_TORP_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_L" } },
      { "type": "thruster", "at": { "socket": "ENG_MAIN_R" } },
      { "type": "shieldGen", "at": { "bounds": [0, 0.3, 0.1] } },
      { "type": "radiator", "at": { "bounds": [-0.8, -0.2, 0.5] } },
      { "type": "radiator", "at": { "bounds": [0.8, -0.2, 0.5] } },
      { "type": "dataCore", "at": { "bounds": [0, 0.5, -0.2] } }
    ]
  },
  "deathWreck": { "lootCheckSeconds": 600, "lootChance": 0.5 },
  "derelict": {
    "sections": [
      {
        "id": "lower_breach",
        "center": [0, -2, 0],
        "parts": [
          { "type": "dataCore", "offset": [7.9, 2, 0], "condition": 0.85 },
          { "type": "reactor", "offset": [0, -4, 7.9] },
          { "type": "radiator", "offset": [-7.9, 3, 0] }
        ]
      },
      {
        "id": "upper_breach",
        "center": [0, 58, 0],
        "parts": [
          { "type": "dataCore", "offset": [0, 3, -7.9], "condition": 0.7 },
          { "type": "shieldGen", "offset": [7.9, -2, 0] },
          { "type": "weapon", "offset": [-7.9, 4, 0] }
        ]
      },
      {
        "id": "broken_hab",
        "center": [-53.26, 40, -30.75],
        "parts": [
          { "type": "dataCore", "offset": [0, 6.3, 0], "condition": 0.6 },
          { "type": "radiator", "offset": [4.3, 0, 0] },
          { "type": "shieldGen", "offset": [-4.3, -2, 0] }
        ]
      },
      {
        "id": "refinery",
        "center": [0, -92, 0],
        "parts": [
          { "type": "reactor", "offset": [18.5, 0, 0] },
          { "type": "reactor", "offset": [-18.5, -5, 0] },
          { "type": "thruster", "offset": [0, -26.5, 0] },
          { "type": "radiator", "offset": [0, 5, 15.5] }
        ]
      },
      {
        "id": "dock",
        "center": [0, 111, 0],
        "parts": [
          { "type": "dataCore", "offset": [0, 23.5, 0], "condition": 0.95 },
          { "type": "weapon", "offset": [29.8, 0, 0] },
          { "type": "weapon", "offset": [-29.8, 0, 0] },
          { "type": "shieldGen", "offset": [0, 10, 29.8] }
        ]
      }
    ]
  }
}
